import { useCallback, useEffect, useState } from "react";
import { fetchRoles, getRoleErrorMessage } from "@/features/role/services/roleService";
const useRoles = (options = {}) => {
    const [roles, setRoles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const loadRoles = useCallback(async () => {
        setLoading(true);
        try {
            const result = await fetchRoles({
                all: true,
                ...(options.includeInactive ? {} : { is_active: true }),
            });
            setRoles(result);
            setError(null);
        }
        catch (apiError) {
            setError(getRoleErrorMessage(apiError));
        }
        finally {
            setLoading(false);
        }
    }, [options.includeInactive]);
    useEffect(() => {
        void loadRoles();
    }, [loadRoles]);
    return { roles, loading, error, refetchRoles: loadRoles };
};
export default useRoles;
